"use client";
import { useEffect } from "react";
import { installDiagnostics } from "../lib/diagnostics.js";

export function DiagnosticsMount() {
  useEffect(() => { installDiagnostics(); }, []);
  return null;
}
